<template>
    <div class="card-item">
        <div class="container py-5">
           <h3 class="text-center mb-5">Portfolios</h3>
            <div class="row">
                <div v-for="portfolio in portfolios" :key="portfolio.id" class="col-md-6 col-sm-12 mb-4">
                    <div class="card">
                        <div class="ribbon"><span>{{ portfolio.backend }}</span></div>
                        <img :src="portfolio.image" width="100%" alt="WEBSITE DESIGN" class="card-img">
                      </div>
                      <p class="lead">{{ portfolio.name }}<button class="btn btn-primary float-right">Visit Now</button></p>
                      
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import db from './firebaseInit'
export default {
    name: "Card",
    data() {
    return {
      portfolios : []
    }
  },
  created () {
      db.collection('portfolios').get().then((querySnapshot) => {
        this.loading = false
        querySnapshot.forEach((doc) => {
          const data = {
            'id': doc.id,
            'name': doc.data().name,
            'image': doc.data().image,
            'backend': doc.data().backend
          }
          this.portfolios.push(data)
        })
      })
    },
}
</script>

<style scoped>
*, *::before, *::after {

  font-family: "Montserrat", sans-serif;
  color: #000;
}
.card{
  width: 100%;
  height: 300px; /* half image height*/
  margin-bottom: 10px;
  position: relative;
  overflow: hidden;
  margin-bottom: 30px;
  border: none;
  background: #fff;
  cursor: pointer;
  transition: transform .5s;
}
/* .card img{
  position: absolute;
  left: 0;
  top: 0;
  transition: transform 1s ease-in-out 0.5s;
}
.card:hover{
    box-shadow: 8px 14px 38px rgba(39,44,49,.06), 1px 3px 8px rgba(39,44,49,.03);
}
.card:hover img {
  transform: translateY(-50%);
} */
img {
  max-width: 100%;
  cusor: pointer;
}
.card:hover img {
  animation: moveSlideshow 3s linear;
}
.card:hover{
    /* box-shadow: 8px 14px 38px rgba(39,44,49,.06), 1px 3px 8px rgba(39,44,49,.03); */
    transition: opacity 2s cubic-bezier(0.165, 0.84, 0.44, 1);
    box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.15);
    transform: scale3d(1.006, 1.006, 1);
}
@keyframes moveSlideshow {
  100% {
    transform: translateY(-60%);
  }
}
.ribbon {
  position: absolute;
  left: -5px; top: -5px;
  z-index: 1;
  overflow: hidden;
  width: 75px; height: 75px;
  text-align: right;
}
.ribbon span {
  font-size: 10px;
  font-weight: bold;
  color: #FFF;
  text-transform: uppercase;
  text-align: center;
  line-height: 20px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  width: 100px;
  display: block;
  background: #79A70A;
  background: linear-gradient(#04D25A 0%, #04BA50 100%);
  box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
  position: absolute;
  top: 19px; left: -21px;
}
.ribbon span::before {
  content: "";
  position: absolute; left: 0px; top: 100%;
  z-index: -1;
  border-left: 3px solid #04BA50;
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #04BA50;
}
.ribbon span::after {
  content: "";
  position: absolute; right: 0px; top: 100%;
  z-index: -1;
  border-left: 3px solid transparent;
  border-right: 3px solid #04BA50;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #04BA50;
}
</style>
